import {useHistoryAssetsQuery} from '@domain/assets'
import {
  useCurrentMaterialStorages,
  isStorageWithMaterialGuard,
  getOptimizedMaterialIdsWithStorages
} from '@domain/material-storage'
import {useMaterialsRecipesById} from '@domain/materials'
import {usePlanningChartStartEnd} from '@widgets/planning-schedule-chart'
import {useMemo} from 'react'

export function useGetOptimizedMaterialIds(plantCode: string) {
  const {startOfPlan, endOfPlan} = usePlanningChartStartEnd()

  const {data: storagesWithMaterial} = useCurrentMaterialStorages({
    plantId: plantCode,
    options: {select: (storages) => storages.filter(isStorageWithMaterialGuard), throwOnError: true}
  })

  const {data: assets} = useHistoryAssetsQuery({
    plantId: plantCode,
    timeFrame: [startOfPlan, endOfPlan]
  })
  const {data: recipesById} = useMaterialsRecipesById({plantId: plantCode})
  return useMemo(
    () =>
      assets && recipesById && storagesWithMaterial
        ? getOptimizedMaterialIdsWithStorages({assets, recipesById, storagesWithMaterial})
        : undefined,
    [recipesById, assets, storagesWithMaterial]
  )
}
